import React, { useEffect, useState } from 'react';
import User from '../../../interfaces/user';
import {
  ACTIPAY_DEV_HEADER_STORAGE_KEY,
  canSetHeader,
} from '../../../hook/useActipayTracking';

const TrackingHeader = ({ user }: { user: User | undefined }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [headerName, setHeaderName] = useState('X-Gtm-Server-Preview');
  const [headerValue, setHeaderValue] = useState('');

  useEffect(() => {
    try {
      const storedHeader = JSON.parse(
        localStorage.getItem(ACTIPAY_DEV_HEADER_STORAGE_KEY) || 'null',
      );
      if (storedHeader?.name) setHeaderName(storedHeader.name);
      if (storedHeader?.value) setHeaderValue(storedHeader.value);
    } catch {
      // Ignore malformed local development configuration.
    }
  }, []);

  const saveHeader = () => {
    if (!headerName.trim() || !headerValue.trim()) {
      localStorage.removeItem(ACTIPAY_DEV_HEADER_STORAGE_KEY);
    } else {
      localStorage.setItem(
        ACTIPAY_DEV_HEADER_STORAGE_KEY,
        JSON.stringify({ name: headerName.trim(), value: headerValue.trim() }),
      );
    }
    setIsOpen(false);
  };

  const clearHeader = () => {
    localStorage.removeItem(ACTIPAY_DEV_HEADER_STORAGE_KEY);
    setHeaderValue('');
    setIsOpen(false);
  };

  if (!user || user.dataLocation !== 'dev' || !canSetHeader()) return <></>;

  return (
    <div className="relative flex items-cent justify-end p-4">
      <button
        type="button"
        className="rounded bg-slate-700 px-3 py-2 text-sm text-white shadow"
        onClick={() => setIsOpen((open) => !open)}
      >
        Tracking header
      </button>
      {isOpen && (
        <div className="absolute bottom-12 right-12 mt-2 w-80 rounded bg-white p-4 shadow-lg">
          <p className="mb-3 text-sm font-medium">Header de tracking (dev)</p>
          <input
            className="mb-2 w-full rounded border px-2 py-1 text-sm"
            value={headerName}
            onChange={(event) => setHeaderName(event.target.value)}
            placeholder="Nom du header"
            aria-label="Nom du header de tracking"
          />
          <input
            className="mb-3 w-full rounded border px-2 py-1 text-sm"
            value={headerValue}
            onChange={(event) => setHeaderValue(event.target.value)}
            placeholder="Valeur du header"
            aria-label="Valeur du header de tracking"
          />
          <div className="flex justify-end gap-2">
            <button type="button" className="text-sm" onClick={clearHeader}>
              Effacer
            </button>
            <button
              type="button"
              className="rounded bg-blue-600 px-3 py-1 text-sm text-white"
              onClick={saveHeader}
            >
              Enregistrer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackingHeader;
